import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';

// GET categories
export const REQUEST_GET_CATEGORIES = 'REQUEST_GET_CATEGORIES';
export const REQUEST_GET_CATEGORIES_SUCCESS = 'REQUEST_GET_CATEGORIES_SUCCESS';
export const REQUEST_GET_CATEGORIES_FAILURE = 'REQUEST_GET_CATEGORIES_FAILURE';
export const ACTION_GET_CATEGORIES = 'ACTION_GET_CATEGORIES';
export const UPDATE_CATEGORY_FILTER = 'UPDATE_CATEGORY_FILTER'

// Update logo option
export const UPDATE_LOGO_OPTION = 'UPDATE_LOGO_OPTION';

// POST upload image
export const REQUEST_POST_IMAGE = 'REQUEST_POST_IMAGE';
export const REQUEST_POST_IMAGE_SUCCESS = 'REQUEST_POST_IMAGE_SUCCESS';
export const REQUEST_POST_IMAGE_FAILURE = 'REQUEST_POST_IMAGE_FAILURE';
export const ACTION_POST_IMAGE = 'ACTION_POST_IMAGE';

export const SET_TAB = 'SET_TAB';
export const SET_PREV_TAB = 'SET_PREV_TAB';
export const SET_OFFER = 'SET_OFFER';
export const CLOSE_TOAST_ALERT = 'CLOSE_TOAST_ALERT';
export const SHOW_TOAST_ALERT = 'SHOW_TOAST_ALERT';

export const REQUEST_RETAILERS = 'REQUEST_RETAILERS';
export const REQUEST_RETAILERS_SUCCESS = 'REQUEST_RETAILERS_SUCCESS';
export const REQUEST_RETAILERS_FAILURE = 'REQUEST_RETAILERS_FAILURE';
export const ACTION_REQUEST_RETAILERS = 'ACTION_REQUEST_RETAILERS';

// GET marketplace items
export const REQUEST_MARKETPLACE_ITEMS = 'REQUEST_MARKETPLACE_ITEMS';
export const REQUEST_MARKETPLACE_ITEMS_SUCCESS = 'REQUEST_MARKETPLACE_ITEMS_SUCCESS';
export const REQUEST_MARKETPLACE_ITEMS_FAILURE = 'REQUEST_MARKETPLACE_ITEMS_FAILURE';
export const ACTION_GET_CATEGORIES_ITEMS = 'ACTION_GET_CATEGORIES_ITEMS';

// GET marketplace item
export const REQUEST_MARKETPLACE_ITEM = 'REQUEST_MARKETPLACE_ITEM';
export const REQUEST_MARKETPLACE_ITEM_SUCCESS = 'REQUEST_MARKETPLACE_ITEM_SUCCESS';
export const REQUEST_MARKETPLACE_ITEM_FAILURE = 'REQUEST_MARKETPLACE_ITEM_FAILURE';
export const ACTION_GET_MARKETPLACE_ITEM = 'ACTION_GET_MARKETPLACE_ITEM';
export const RESET_MARKETPLACE_ITEM = 'RESET_MARKETPLACE_ITEM';

// POST marketplace item
export const REQUEST_CREATE_MARKETPLACE_ITEM = 'REQUEST_CREATE_MARKETPLACE_ITEM';
export const REQUEST_CREATE_MARKETPLACE_ITEM_SUCCESS = 'REQUEST_CREATE_MARKETPLACE_ITEM_SUCCESS';
export const REQUEST_CREATE_MARKETPLACE_ITEM_FAILURE = 'REQUEST_CREATE_MARKETPLACE_ITEM_FAILURE';
export const ACTION_CREATE_MARKETPLACE_ITEM = 'ACTION_CREATE_MARKETPLACE_ITEM';
export const UPDATE_MARKETPLACE_ITEM = 'UPDATE_MARKETPLACE_ITEM';

// GET countries
export const REQUEST_GET_COUNTRIES = 'REQUEST_GET_COUNTRIES';
export const REQUEST_GET_COUNTRIES_SUCCESS = 'REQUEST_GET_COUNTRIES_SUCCESS';
export const REQUEST_GET_COUNTRIES_FAILURE = 'REQUEST_GET_COUNTRIES_FAILURE';
export const ACTION_GET_COUNTRIES = 'ACTION_GET_COUNTRIES';

export const REQUEST_COUNTRIES = 'REQUEST_COUNTRIES';
export const REQUEST_COUNTRIES_SUCCESS = 'REQUEST_COUNTRIES_SUCCESS';
export const REQUEST_COUNTRIES_FAILURE = 'REQUEST_COUNTRIES_FAILURE';
export const ACTION_REQUEST_COUNTRIES = 'ACTION_REQUEST_COUNTRIES';

export const REQUEST_CATEGORIES = 'REQUEST_CATEGORIES';
export const REQUEST_CATEGORIES_SUCCESS = 'REQUEST_CATEGORIES_SUCCESS';
export const REQUEST_CATEGORIES_FAILURE = 'REQUEST_CATEGORIES_FAILURE';

export const REQUEST_SWAP_HISTORY = 'REQUEST_SWAP_HISTORY';
export const REQUEST_SWAP_HISTORY_SUCCESS = 'REQUEST_SWAP_HISTORY_SUCCESS';
export const REQUEST_SWAP_HISTORY_FAILURE = 'REQUEST_SWAP_HISTORY_FAILURE';

export const REQUEST_BUY_REDEEM = 'REQUEST_BUY_REDEEM';
export const REQUEST_BUY_REDEEM_SUCCESS = 'REQUEST_BUY_REDEEM_SUCCESS';
export const REQUEST_BUY_REDEEM_FAILURE = 'REQUEST_BUY_REDEEM_FAILURE';
export const ACTION_BUY_REDEEM = 'ACTION_BUY_REDEEM';

export const ACTION_POST_CONFIRM_DELIVERY = 'ACTION_POST_CONFIRM_DELIVERY';
export const REQUEST_CONFIRM_DELIVERY = 'REQUEST_CONFIRM_DELIVERY';
export const REQUEST_CONFIRM_DELIVERY_SUCCESS = 'REQUEST_CONFIRM_DELIVERY_SUCCESS';
export const REQUEST_CONFIRM_DELIVERY_FAILURE = 'REQUEST_CONFIRM_DELIVERY_FAILURE';

export const ACTION_SET_ITEM_MARKETPLACE_TO_REPORT = 'ACTION_SET_ITEM_MARKETPLACE_TO_REPORT';
export const ACTION_POST_REPORT_MARKETPLACE_ITEM = 'ACTION_POST_REPORT_MARKETPLACE_ITEM';
export const REQUEST_REPORT_MARKETPLACE_ITEM = 'REQUEST_REPORT_MARKETPLACE_ITEM';
export const REQUEST_REPORT_MARKETPLACE_ITEM_SUCCESS = 'REQUEST_REPORT_MARKETPLACE_ITEM_SUCCESS';
export const REQUEST_REPORT_MARKETPLACE_ITEM_FAILURE = 'REQUEST_REPORT_MARKETPLACE_ITEM_FAILURE';

export const UPDATE_FILTER = 'UPDATE_FILTER';

const defaultState = {
  //Get marketplace categories
  category: {},
  categoryError: {},
  fetchingMarketplace: false,
  failedFetchingMarketplace: false,
  categoryFilter: {
    page: 1,
    limit: 10,
    q: '',
  },

  // Get countries
  countries: [],
  countriesError: {},
  isRequestingCountries: false,
  isGetCountriesSuccess: false,
  isGetCountriesFailure: false,

  // POST Marketplace
  marketplaceItem: {},
  marketplaceItemError: {},
  isRequestingPostMarketplace: false,
  isPostMarketplaceSuccess: false,
  isPostMarketplaceFailure: false,

  // POST image
  imageLink: {},
  imageLinkError: {},
  isRequestingPostImage: false,
  isPostImageSuccess: false,
  isPostImageFailure: false,

  prevTab: 'userMarketSelectTab',
  currentTab: 'userMarketSelectTab',
  orderId: '',
  offer: {},
  isShowToastAlert: false,
  toastAlertPayload: {
    type: 'success',
    message: '',
  },

  retailerFilter: {
    limit: 10,
    page: 1,
  },

  retailers: [],
  fetchingRetailers: true,
  failedFetchingRetailers: false,

  marketplaceItemsFilter: {
    limit: 10,
    page: 1,
    // orderField: '',
    // orderDirection: 'DESC',
  },
  marketplaceItems: [],
  fetchingMarketplaceItems: true,
  failedFetchingMarketplaceItems: false,

  categoriesFilter: {
    limit: 31,
    page: 1,
  },

  categories: [],
  fetchingCategories: true,
  failedFetchingCategories: false,

  countriesFilter: {
    limit: 10,
    page: 1,
  },
  fetchingCountries: true,
  failedFetchingCountries: false,

  swapHistoryFilter: {
    limit: 5,
    page: 1,
    q: '',
  },
  swapHistory: [],
  fetchingSwapHistory: true,
  failedFetchingSwapHistory: false,

  redeem: {},
  redeemOrder: null, // Store complete order data from buyRedeem response
  fetchingRedeem: true,
  failedFetchingRedeem: false,

  redeemDeli: {},
  redeemDeliError: {},
  isRequestingConfirmDelivery: false,
  isConfirmDeliverySuccess: false,
  isConfirmDeliveryFailure: false,

  error: '',
  // Create marketplace item
  isRequestingCreateMarketplaceItem: false,
  isCreateMarketplaceItemSuccess: false,
  isCreateMarketplaceItemFailure: false,

  // GET marketplace item
  item: {},
  itemError: {},
  isRequestingGetItem: false,
  isGetItemSucceed: false,
  isGetItemFailure: false,

  // report
  itemToReport: null,
  requestingReportItem: false,
  failedRequestingReportItem: false,
};

const reducer = createReducer(defaultState, {
  // GET marketplace
  [REQUEST_GET_CATEGORIES]: (state) => ({
    ...state,
    fetchingMarketplace: true,
    failedFetchingMarketplace: false,
  }),
  [REQUEST_GET_CATEGORIES_SUCCESS]: (state, action) => ({
    ...state,
    category: action.payload,
    fetchingMarketplace: false,
    failedFetchingMarketplace: false,
  }),
  [REQUEST_GET_CATEGORIES_FAILURE]: (state, action) => ({
    ...state,
    categoryError: action.payload,
    fetchingMarketplace: false,
    failedFetchingMarketplace: true,
  }),
  // POST marketplace
  [REQUEST_CREATE_MARKETPLACE_ITEM]: (state, _action) => ({
    ...state,
    isRequestingPostMarketplace: true,
  }),
  [REQUEST_CREATE_MARKETPLACE_ITEM_SUCCESS]: (state, action) => ({
    ...state,
    marketplaceItem: action.payload,
    isRequestingPostMarketplace: false,
    isPostMarketplaceFailure: false,
    isPostMarketplaceSuccess: true,
  }),
  [REQUEST_CREATE_MARKETPLACE_ITEM_FAILURE]: (state, action) => ({
    ...state,
    marketplaceItemError: action.payload,
    isRequestingPostMarketplace: false,
    isPostMarketplaceFailure: true,
    isPostMarketplaceSuccess: false,
  }),
  // Update marketplace item
  [UPDATE_MARKETPLACE_ITEM]: (state, action) => ({
    ...state,
    marketplaceItem: { ...state.marketplaceItem, ...action.payload },
  }),
  // Update logo option
  [UPDATE_LOGO_OPTION]: (state, action) => ({
    ...state,
    logoOption: action.payload,
  }),
  // Post image
  [REQUEST_POST_IMAGE]: (state, _action) => ({
    ...state,
    isRequestingPostImage: true,
  }),
  [REQUEST_POST_IMAGE_SUCCESS]: (state, action) => ({
    ...state,
    imageLink: action.payload,
    isRequestingPostImage: false,
    isPostImageFailure: false,
    isPostImageSuccess: true,
  }),
  [REQUEST_POST_IMAGE_FAILURE]: (state, action) => ({
    ...state,
    imageLinkError: action.payload,
    isRequestingPostImage: false,
    isPostImageFailure: true,
    isPostImageSuccess: false,
  }),
  [SET_TAB]: (state, action) => ({
    ...state,
    currentTab: action.payload,
  }),
  [SET_PREV_TAB]: (state, action) => ({
    ...state,
    prevTab: action.payload,
  }),
  [SET_OFFER]: (state, action) => ({
    ...state,
    offer: action.payload,
  }),

  [SHOW_TOAST_ALERT]: (state, action) => ({
    ...state,
    isShowToastAlert: true,
    toastAlertPayload: action.payload,
  }),
  [CLOSE_TOAST_ALERT]: (state) => ({
    ...state,
    isShowToastAlert: false,
    toastAlertPayload: {
      type: 'success',
      message: '',
    },
  }),

  [REQUEST_RETAILERS]: (state, _action) => ({
    ...state,
    fetchingRetailers: true,
    failedFetchingRetailers: false,
  }),
  [REQUEST_RETAILERS_SUCCESS]: (state, action) => ({
    ...state,
    retailers: action.payload,
    fetchingRetailers: false,
    failedFetchingRetailers: false,
  }),
  [REQUEST_RETAILERS_FAILURE]: (state, _action) => ({
    ...state,
    fetchingRetailers: false,
    failedFetchingRetailers: true,
  }),

  [REQUEST_MARKETPLACE_ITEMS]: (state, _action) => ({
    ...state,
    fetchingMarketplaceItems: true,
    failedFetchingMarketplaceItems: false,
  }),
  [REQUEST_MARKETPLACE_ITEMS_SUCCESS]: (state, action) => ({
    ...state,
    marketplaceItems: action.payload,
    fetchingMarketplaceItems: false,
    failedFetchingMarketplaceItems: false,
  }),
  [REQUEST_MARKETPLACE_ITEMS_FAILURE]: (state, _action) => ({
    ...state,
    fetchingMarketplaceItems: false,
    failedFetchingMarketplaceItems: true,
  }),

  [REQUEST_CATEGORIES]: (state, _action) => ({
    ...state,
    fetchingCategories: true,
    failedFetchingCategories: false,
  }),
  [REQUEST_CATEGORIES_SUCCESS]: (state, action) => ({
    ...state,
    categories: action.payload,
    fetchingCategories: false,
    failedFetchingCategories: false,
  }),
  [REQUEST_CATEGORIES_FAILURE]: (state, _action) => ({
    ...state,
    fetchingCategories: false,
    failedFetchingCategories: true,
  }),

  [REQUEST_COUNTRIES]: (state, _action) => ({
    ...state,
    fetchingCountries: true,
    failedFetchingCountries: false,
  }),
  [REQUEST_COUNTRIES_SUCCESS]: (state, action) => ({
    ...state,
    countries: [{ id: '', iso: '', name: 'All Country' }, ...(action.payload?.data?.items || [])],
    fetchingCountries: false,
    failedFetchingCountries: false,
  }),
  [REQUEST_COUNTRIES_FAILURE]: (state, _action) => ({
    ...state,
    fetchingCountries: false,
    failedFetchingCountries: true,
  }),

  [REQUEST_SWAP_HISTORY]: (state, _action) => ({
    ...state,
    fetchingSwapHistory: true,
    failedFetchingSwapHistory: false,
  }),
  [REQUEST_SWAP_HISTORY_SUCCESS]: (state, action) => ({
    ...state,
    swapHistory: action.payload,
    fetchingSwapHistory: false,
    failedFetchingSwapHistory: false,
  }),
  [REQUEST_SWAP_HISTORY_FAILURE]: (state, _action) => ({
    ...state,
    fetchingSwapHistory: false,
    failedFetchingSwapHistory: true,
  }),

  [REQUEST_BUY_REDEEM]: (state, _action) => {
    return {
      ...state,
      fetchingRedeem: true,
      failedFetchingRedeem: false,
    };
  },
  [REQUEST_BUY_REDEEM_SUCCESS]: (state, action) => ({
    ...state,
    redeem: action.payload,
    redeemOrder: action.payload?.data, // Store complete order data including marketplaceItem
    fetchingRedeem: false,
    failedFetchingRedeem: false,
  }),
  [REQUEST_BUY_REDEEM_FAILURE]: (state, action) => {
    console.log('index ', action);

    return {
      ...state,
      fetchingRedeem: false,
      failedFetchingRedeem: true,
      error: action.payload,
    };
  },

  [ACTION_BUY_REDEEM]: (state, _action) => ({
    ...state,
  }),

  [REQUEST_CONFIRM_DELIVERY]: (state, _action) => ({
    ...state,
    isRequestingConfirmDelivery: true,
  }),
  [REQUEST_CONFIRM_DELIVERY_SUCCESS]: (state, action) => ({
    ...state,
    redeemDeli: action.payload,
    isRequestingConfirmDelivery: false,
    isConfirmDeliveryFailure: false,
    isConfirmDeliverySuccess: true,
  }),
  [REQUEST_CONFIRM_DELIVERY_FAILURE]: (state, action) => ({
    ...state,
    redeemDeliError: action.payload,
    isRequestingConfirmDelivery: false,
    isConfirmDeliveryFailure: true,
    isConfirmDeliverySuccess: false,
  }),
  [UPDATE_FILTER]: (state, action) => ({
    ...state,
    swapHistoryFilter: action.payload,
  }),
  [UPDATE_CATEGORY_FILTER]: (state, action) => ({
    ...state,
    categoryFilter: action.payload,
  }),
  // Get Marketplace item
  [REQUEST_MARKETPLACE_ITEM]: (state, _action) => ({
    ...state,
    isRequestingGetItem: true,
  }),
  [REQUEST_MARKETPLACE_ITEM_SUCCESS]: (state, action) => ({
    ...state,
    item: action.payload,
    offer: action.payload.data,
    isRequestingGetItem: false,
    isGetItemSucceed: true,
    isGetItemFailure: false,
  }),
  [REQUEST_MARKETPLACE_ITEM_FAILURE]: (state, action) => ({
    ...state,
    itemError: action.payload,
    isRequestingGetItem: false,
    isGetItemFailure: true,
    isGetItemSucceed: false,
  }),
  [RESET_MARKETPLACE_ITEM]: (state, _action) => ({
    ...state,
    item: {},
  }),
  [ACTION_SET_ITEM_MARKETPLACE_TO_REPORT]: (state, action) => ({
    ...state,
    itemToReport: action?.payload,
  }),
  [REQUEST_REPORT_MARKETPLACE_ITEM]: (state, _action) => ({
    ...state,
    requestingReportItem: true,
    failedRequestingReportItem: false,
  }),
  [REQUEST_REPORT_MARKETPLACE_ITEM_SUCCESS]: (state, _action) => ({
    ...state,
    requestingReportItem: false,
    failedRequestingReportItem: false,
  }),
  [REQUEST_REPORT_MARKETPLACE_ITEM_FAILURE]: (state, _action) => ({
    ...state,
    requestingReportItem: false,
    failedRequestingReportItem: true,
  }),
});

export default reducer;
export const namespace = 'marketplace';

export const setTab = (tab) => ({ type: SET_TAB, payload: tab });
export const setPrevTab = (tab) => ({ type: SET_PREV_TAB, payload: tab });
export const setOffer = (offer) => ({ type: SET_OFFER, payload: offer });
// export const setError = (error) => ({ type: SET_ERROR, payload: error });

export const actionUpdateFilter = (filters) => ({
  type: UPDATE_FILTER,
  payload: filters,
});

export const actionUpdateCategoryFilter = (filter) => ({
  type: UPDATE_CATEGORY_FILTER,
  payload: filter,
});

export const actionCreateRedeem = (newRedeem) => ({
  type: ACTION_BUY_REDEEM,
  payload: newRedeem,
});

export const showToastAlert = (message = '', type = 'success') => ({
  type: SHOW_TOAST_ALERT,
  payload: {
    type,
    message,
  },
});

export const closeToastAlert = () => ({
  type: CLOSE_TOAST_ALERT,
});
export const actionRequestMarketplace = () => ({
  type: ACTION_GET_CATEGORIES,
});

export const actionGetMarketplaceItem = () => ({
  type: ACTION_GET_MARKETPLACE_ITEM,
});

export const resetMarketplaceItem = () => ({
  type: RESET_MARKETPLACE_ITEM,
});

export const updateMarketplaceItem = (payload) => ({
  type: 'UPDATE_MARKETPLACE_ITEM',
  payload,
});

export const updateLogoOption = (payload) => ({
  type: 'UPDATE_LOGO_OPTION',
  payload: payload,
});

export const actionPostImage = (payload) => ({
  type: 'ACTION_POST_IMAGE',
  payload: payload,
});

export const actionCreateItem = (payload) => ({
  type: 'ACTION_CREATE_MARKETPLACE_ITEM',
  payload: payload,
});

export const actionGetCountries = () => ({
  type: 'ACTION_GET_COUNTRIES',
});

export const postConfirmDelivery = (payload) => ({
  type: ACTION_POST_CONFIRM_DELIVERY,
  payload: payload,
});

export const setItemToReport = (payload) => ({
  type: ACTION_SET_ITEM_MARKETPLACE_TO_REPORT,
  payload: payload,
});

export const postReportItem = (payload) => ({
  type: ACTION_POST_REPORT_MARKETPLACE_ITEM,
  payload: payload,
});

// Create marketplace item
export const createMarketplaceItemAPI = (marketplaceData) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/marketplace/create',
    actionTypes: [
      REQUEST_CREATE_MARKETPLACE_ITEM,
      REQUEST_CREATE_MARKETPLACE_ITEM_SUCCESS,
      REQUEST_CREATE_MARKETPLACE_ITEM_FAILURE,
    ],
    variables: {
      ...marketplaceData,
    },
    dispatch,
    getState,
  });
};

export const getMarketplaceItemsAPI = (marketplaceData) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/marketplace',
    actionTypes: [
      REQUEST_MARKETPLACE_ITEMS,
      REQUEST_MARKETPLACE_ITEMS_SUCCESS,
      REQUEST_MARKETPLACE_ITEMS_FAILURE,
    ],
    variables: {
      ...marketplaceData,
    },
    dispatch,
    getState,
  });
};

// Get all the categories marketplace
export const getCategoriesAPI = (marketplaceData) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: 'categories/marketplace?page=1&limit=49',
    actionTypes: [
      REQUEST_GET_CATEGORIES,
      REQUEST_GET_CATEGORIES_SUCCESS,
      REQUEST_GET_CATEGORIES_FAILURE,
    ],
    variables: {
      ...marketplaceData,
    },
    dispatch,
    getState,
  });
};

export const getCountriesAPI = () => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/countries',
    actionTypes: [
      REQUEST_GET_COUNTRIES,
      REQUEST_GET_COUNTRIES_SUCCESS,
      REQUEST_GET_COUNTRIES_FAILURE,
    ],
    dispatch,
    getState,
  });
};

export const postImageAPI = (file) => async (dispatch, getState) => {
  let formData = new FormData();
  formData.append('file', file);

  return await callAPI({
    method: 'post',
    apiPath: '/upload',
    actionTypes: [REQUEST_POST_IMAGE, REQUEST_POST_IMAGE_SUCCESS, REQUEST_POST_IMAGE_FAILURE],
    variables: formData,
    dispatch,
    getState,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getRetailersApi = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/retailers',
    actionTypes: [REQUEST_RETAILERS, REQUEST_RETAILERS_SUCCESS, REQUEST_RETAILERS_FAILURE],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const getCategoriesApi = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/categories/marketplace',
    actionTypes: [REQUEST_CATEGORIES, REQUEST_CATEGORIES_SUCCESS, REQUEST_CATEGORIES_FAILURE],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const getMarketplaceItemAPI = (itemId) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: `/marketplace/${itemId}`,
    actionTypes: [
      REQUEST_MARKETPLACE_ITEM,
      REQUEST_MARKETPLACE_ITEM_SUCCESS,
      REQUEST_MARKETPLACE_ITEM_FAILURE,
    ],
    variables: {
      ...itemId,
    },
    dispatch,
    getState,
  });
};

export const getCountriesApi = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/countries',
    actionTypes: [REQUEST_COUNTRIES, REQUEST_COUNTRIES_SUCCESS, REQUEST_COUNTRIES_FAILURE],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const confirmDeli = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/orders/redeem/confirm-delivery',
    actionTypes: [
      REQUEST_CONFIRM_DELIVERY,
      REQUEST_CONFIRM_DELIVERY_SUCCESS,
      REQUEST_CONFIRM_DELIVERY_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const buyRedeem = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/orders/redeem',
    actionTypes: [REQUEST_BUY_REDEEM, REQUEST_BUY_REDEEM_SUCCESS, REQUEST_BUY_REDEEM_FAILURE],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const reportItemAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/violations',
    actionTypes: [
      REQUEST_REPORT_MARKETPLACE_ITEM,
      REQUEST_REPORT_MARKETPLACE_ITEM_SUCCESS,
      REQUEST_REPORT_MARKETPLACE_ITEM_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};
